export const comments_3389326 = {"data":{"data":[],"links":{}}}